import { ObservableChangeEvent, Plugin } from 'ckeditor5';

export class BalloonToolbarWorkaround extends Plugin {
  private _showTimeoutId?: ReturnType<typeof setTimeout>;

  static get pluginName() {
    return 'BalloonToolbarWorkaround';
  }

  init() {
    const editor = this.editor;

    if (
      !editor.plugins.has('BalloonToolbar') ||
      !editor.plugins.has('ContextualBalloon')
    ) {
      return;
    }

    const balloonToolbar = editor.plugins.get('BalloonToolbar');
    const balloon = editor.plugins.get('ContextualBalloon');

    const isOtherViewVisible = () => {
      const visibleView = balloon.visibleView;

      return !!visibleView && visibleView !== balloonToolbar.toolbarView;
    };

    const showWhenOtherViewsAreGone = () => {
      if (!isOtherViewVisible()) {
        this.stopListening(
          balloon,
          'change:visibleView',
          showWhenOtherViewsAreGone,
        );

        // change:visibleView fires mid ContextualBalloon#remove(); a synchronous show() stays hidden.
        clearTimeout(this._showTimeoutId);

        this._showTimeoutId = setTimeout(() => {
          if (balloonToolbar.focusTracker.isFocused) {
            balloonToolbar.show();
          }
        });
      }
    };

    this.listenTo(
      balloonToolbar,
      'show',
      (evt) => {
        if (isOtherViewVisible()) {
          evt.stop();

          this.stopListening(
            balloon,
            'change:visibleView',
            showWhenOtherViewsAreGone,
          );
          this.listenTo(
            balloon,
            'change:visibleView',
            showWhenOtherViewsAreGone,
          );
        }
      },
      { priority: 'high' },
    );

    this.listenTo<ObservableChangeEvent<boolean>>(
      balloonToolbar.focusTracker,
      'change:isFocused',
      (_evt, _name, isFocused) => {
        if (!isFocused) {
          this.stopListening(
            balloon,
            'change:visibleView',
            showWhenOtherViewsAreGone,
          );
          clearTimeout(this._showTimeoutId);
        }
      },
    );
  }

  destroy() {
    clearTimeout(this._showTimeoutId);

    super.destroy();
  }
}
